/**
 * IMask calls format(undefined) from typedValueEquals when Angular writes undefined
 * to a number mask — default format uses toLocaleString and throws.
 * @see https://github.com/uNmAnNeR/imaskjs/issues/1080
 */
import IMask from 'imask';

Object.assign(IMask.MaskedNumber.DEFAULTS, {
  format: (n: number | null | undefined) =>
    n?.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20,
    }) ?? '',
});
